import { render, staticRenderFns } from "./appTabs.vue?vue&type=template&id=6fd852e7&"
import script from "./appTabs.vue?vue&type=script&lang=js&"
export * from "./appTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports